import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import BodyukHowitWorks from "./Components/BodyukHowitWorks";

class CHUkHowitWorks extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <BodyukHowitWorks />
        <Footer />
      </>
    );
  }
}

export default CHUkHowitWorks;
